import { ASSETS_ADDRESS } from '../constants';

export const mediaPath = (url: string): string => `${ASSETS_ADDRESS}${url}`;
